import React, { useState, useEffect } from "react";
import { Row, Col, Button, notification, Input, Spin, Select, message, Space } from "antd";
import AppTable from "../../../components/AppTable/AppTable";
import Reassignmodal from "../../../components/AppModal/Reassignmodal";
import Completeform from "../../../components/AppModal/Completeform";
import TripClose from "../../../components/AppModal/TripClose";
import AppModalWithCancelForm from "../../../components/AppModal/AppModalWithCancelForm";
import axiosGet, { axiosPost } from "../../../helpers/AxiosRequest";
import { UrlConstants } from "../../../helpers/UrlConstantsHelper";
import moment from "moment";
import { useHistory, Link } from "react-router-dom";
import { EditOutlined, RedoOutlined, CheckCircleOutlined, RocketOutlined } from "@ant-design/icons";
const { Option } = Select;

const { Search } = Input;

const CurrentBooking = () => {
  let history: any = useHistory();
  const [gridModelVisible, setGridModalVisible] = useState(false);
  const [formModalVisible, setFormModalVisible] = useState(false);
  const [CloseModalVisible, setCloseModalVisible] = useState(false);
  const [cancelformModalVisible, setCancelFormModalVisible] = useState(false);
  const [currentBookingGridData, setCurrentBookingGridData] = useState([]);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [reassigndisabled, setreassigndisabled] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [selectedRowData, setSelectedRowData]: any = useState([]);
  const [SelectedCabData, setSelectedCabData] = useState([]);
  const [selectedCab, setselectedCab]: any = useState("");
  const [searchCabVisible, setSearchCabVisible] = useState(false);
  const [availableCabData, setAvailableCabData] = useState([]);
  const [branchid, setbranchid]: any = useState(localStorage.getItem("cityid"));
  const [Role, setRole]: any = useState(localStorage.getItem("roleid"));

  const [username, setUsername]: any = useState(
    localStorage.getItem("employeename")
  );
  const [employeename, setemployeename]: any = useState(
    localStorage.getItem("employeename")
  );
  const [SearchText, setsearchText] = useState("");
  const [copycurrentBookingGridData, setcopyCurrentBookingGridData] = useState(
    []
  );
  const [isLoading, setIsLoading] = useState(false);
  const [modalloading, setModalLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  let tempavialablecabs: any = [];
  const [pagination, setPagination]: any = useState({
    current: 1,
    pageSize: 10,
  });
  interface FarePreview {
    fare: number;
    duration: number;
    distance: number;
  }

  const [farePreview, setfarePreview] = useState<FarePreview | null>(null);
  const columns = [
    {
      title: "Book ID",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      ellipsis: true,
      //sorter: (a: any, b: any) => a.id - b.id,
      search: false,
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.tripstatuscode === 1
                  ? "#ffff00"
                  : record.tripstatuscode === 2
                    ? "#a4c2f4"
                    : record.tripstatuscode === 3
                      ? "#93c47d"
                      : record.tripstatuscode === 4
                        ? "#f4cccc"
                        : record.vehicletype === "Bolero"
                          ? "#f5d7c6"
                          : record.vehicletype === "407"
                            ? "#fce6fc"
                            : record.vehicletype === "EICHER14"
                              ? "#e1f6f7"
                              : "#ffffff",
            },
          },
          children: <div>{text}</div>,
        };
      },
      width: "110px",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "Name",
      //ellipsis: true,
      //
      fixed: "left",
      search: true,
      render: (text: any, record: any) => {
        return {
          props: {
            //style: { background: record.tripstatuscode===1 ? "#ffff00" : record.tripstatuscode===2 ? "#a4c2f4" : record.tripstatuscode===3 ? "#93c47d" : record.tripstatuscode===4 ? "#f4cccc" : "" }
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: <div>{text}</div>,
        };
      },
      //render: (text: any) => <a>{text}</a>,
      width: "200px",
    },
    {
      title: "Mobile",
      dataIndex: "mobileno",
      ellipsis: true,
      key: "Mobile",
      fixed: "left",
      search: false,
      // render: (text: any, record: any) => {
      //   return record.mobileno + " / " + record.alternativemobileno;
      // },
      render: (text: any, record: any) => {
        return {
          props: {
            //style: { background: record.tripstatuscode===1 ? "#ffff00" : record.tripstatuscode===2 ? "#a4c2f4" : record.tripstatuscode===3 ? "#93c47d" : record.tripstatuscode===4 ? "#f4cccc" : "" }
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: <div>{text?.slice(-10)}</div>,
        };
      },
      width: "110px",
    },

    {
      title: "Cab ID",
      dataIndex: "cabid",
      key: "Cab ID",
      ellipsis: true,
      search: false,
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: <div>{text}</div>,
        };
      },
      width: "85px",
      //render: (text: any) => <a>{text}</a>,
      onHeaderCell: (column: any) => {
        return { width: "85px" };
      },
    },

    {
      title: "Date",
      dataIndex: "assignedtime",
      key: "Date",
      ellipsis: true,
      search: false,
      render: (text: any, record: any) => {
        if (text !== undefined || text !== "")
          return {
            props: {
              style: {
                background:
                  record.vehicletype === "Bolero"
                    ? "#f5d7c6"
                    : record.vehicletype === "407"
                      ? "#fce6fc"
                      : record.vehicletype === "EICHER14"
                        ? "#e1f6f7"
                        : "#ffffff",
              },
            },
            children: <div>{moment(text).format("DD/MM/YYYY")}</div>,
          };
        else
          return {
            props: {
              style: {
                background:
                  record.vehicletype === "Bolero"
                    ? "#f5d7c6"
                    : record.vehicletype === "407"
                      ? "#fce6fc"
                      : record.vehicletype === "EICHER14"
                        ? "#e1f6f7"
                        : "#ffffff",
              },
            },
            //children: <div>{text}</div>,
          };
      },
      width: "110px",
    },
    {
      title: "Time",
      dataIndex: ["bookedtime", "assignedtime", "tripstart"],
      key: "Time",
      ellipsis: true,
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: (
            <div>
              <Row>
                B -{" "}
                {record.bookedtime !== undefined
                  ? moment(record.bookedtime).format("hh:mm A")
                  : ""}
              </Row>
              <Row>
                A -{" "}
                {record.assignedtime !== undefined
                  ? moment(record.assignedtime).format("hh:mm A")
                  : ""}
              </Row>
              {record.tripstart && (
                <Row>
                  S -{" "}
                  {record.tripstart !== undefined
                    ? moment(record.tripstart).format("hh:mm A")
                    : ""}
                </Row>

              )}
              {record.tripend && (
                <Row>
                  E -{" "}
                  {record.tripend !== undefined
                    ? moment(record.tripend).format("hh:mm A")
                    : ""}
                </Row>

              )}
              {record.reassigntime && <Row>
                R -{" "}
                {record.reassigntime !== undefined
                  ? moment(record.reassigntime).format("hh:mm A")
                  : ""} </Row>}

            </div>
          ),
        };
      },
      width: "110px",
    },
    {
      title: "From Location",
      dataIndex: "fromloc",
      key: "From Location",
      //ellipsis: true,
      search: false,
      // sorter: (a: any, b: any) => a.fromloc - b.fromloc,
      //render: (text: any) => <a>{text}</a>,
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: "To Location",
      dataIndex: "toloc",
      key: "To Location",
      //ellipsis: true,
      search: false,
      // sorter: (a: any, b: any) => a.toloc - b.toloc,
      //render: (text: any) => <a>{text}</a>,
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "Remarks",
      //ellipsis: true,
      search: false,
      //render: (text: any) => <a>{text}</a>,
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: "Vehicle",
      dataIndex: "vehicletype",
      key: "Vehicle",
      ellipsis: true,
      search: false,
      //  render: (text: any) => <a>{text}</a>, //=> {
      //     return text;
      //record.vechicledetail.length > 0 && record.vechicledetail[0].Vechicle
      width: "85px",
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: <div>{text}</div>,
        };
      },
    },
    // {
    //   title: "Fare Type",
    //   dataIndex: "faretype",
    //   key: "Fare Type",
    //   align: "center",
    //   filters: [
    //     { text: "Meter Fare", value: "Meter Fare" },
    //     { text: "Package Fare", value: "Package Fare" },
    //     { text: "Intercity Fare", value: "Intercity Fare" },
    //     { text: "Night Fare", value: "Night Fare" },
    //   ],
    //   onFilter: (value: any, record: any) => {
    //     const main = record.faretype?.split("/")?.[0] ?? "";
    //     return main.toLowerCase() === value.toLowerCase();
    //   },

    //   render: (text: any, record: any) => {
    //     return {
    //       props: {
    //         style: {
    //           background:
    //             record.vehicletype === "Bolero"
    //               ? "#f5d7c6"
    //               : record.vehicletype === "407"
    //                 ? "#fce6fc"
    //                 : record.vehicletype === "EICHER14"
    //                   ? "#e1f6f7"
    //                   : "#ffffff",
    //         },
    //       },
    //       children: <div>{text}</div>,
    //     };
    //   },
    // },
    {
      title: "Fare Type",
      dataIndex: "faretype",
      key: "Fare Type",
      //ellipsis: true,
      search: false,
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: "Credit",
      dataIndex: "iscredit",
      key: "Credit",
      ellipsis: true,
      search: false,
      width: "85px",
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: <div>{text}</div>,
        };
      },
      //render: (text: any) => <a>{text}</a>,
    },
    {
      title: "Goods",
      dataIndex: "goods",
      key: "Goods",
      //ellipsis: true,
      search: false,
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: <div>{text}</div>,
        };
      },
      //render: (text: any) => <a>{text}</a>,
    },
    {
      title: "OTP",
      dataIndex: "otp",
      key: "OTP",
      ellipsis: true,
      search: false,
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: <div>{text}</div>,
        };
      },
      //render: (text: any) => <a>{text}</a>,
      width: "85px",
    },
    {
      title: "Booked by",
      dataIndex: ["bookedby", "assignedby"],
      key: "Booked by",
      ellipsis: true,
      search: false,
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: (
            <div>
              <Row>B - {record.bookedby} </Row>
              <Row>A - {record.assignedby} </Row>
              {record.updatedby && <Row>U - {record.updatedby} </Row>}
              {record.reassignby && <Row>R - {record.reassignby} </Row>}
              {record.enquiryby && <Row>E- {record.enquiryby} </Row>}
            </div>
          ),
        };
      },
      width: "110px",
    },
    {
      title: "Vehicle Id",
      dataIndex: "vehicleid",
      key: "Vehicle Id",
      search: false,
      //ellipsis: true,
      // render: (text: any, record: any) => {
      //   //return record.vechicledetail.length > 0 && record.vechicledetail[0].id;
      // },
      width: "110px",
      onHeaderCell: (column: any) => {
        return { width: "110px" };
      },
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: "Alternative",
      dataIndex: "alternativemobileno",
      ellipsis: true,
      key: "Alternative",
      search: false,
      width: "110px",
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: <div>{text?.slice(-10)}</div>,
        };
      },
    },
    {
      title: "City",
      dataIndex: "city",
      key: "City",
      ellipsis: true,
      search: false,
      // sorter: (a: any, b: any) => a.cityid - b.cityid,
      //render: (text: any) => <a>{text}</a>,
      width: "120px",
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: "Edit",
      dataIndex: "vehicleid",
      key: "Vehicle Id1",
      ellipsis: true,
      search: false,
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              background:
                record.vehicletype === "Bolero"
                  ? "#f5d7c6"
                  : record.vehicletype === "407"
                    ? "#fce6fc"
                    : record.vehicletype === "EICHER14"
                      ? "#e1f6f7"
                      : "#ffffff",
            },
          },
          children: (
            <div>
              <Link
                style={{ marginRight: 16 }}
                to={{
                  pathname: "/booking/editBooking",
                  hash: new Date().getTime().toString(),
                  state: { details: record, isCurrentBooking: true },
                }}
              >
                <EditOutlined className="edit-booking" />
              </Link>
            </div>
          ),
        };
      },
      width: "60px",
      // render: (text: any, record: any) => {
      //   //return record.vechicledetail.length > 0 && record.vechicledetail[0].id;
      // },
    },
  ];



  const modalReAssignColumns = (selectedReasons: any, handleReasonChange: any) => {
    const columns: any[] = [
      {
        title: "CabId",
        dataIndex: "cabid",
        key: "cabid",
        fixed: "left",
        render: (text: any, record: any) => (
          <a
            onClick={() =>
              selectedReasons[record.cabid]
                ? onReAssignBooking(null, record, selectedReasons[record.cabid])
                : null
            }
            style={{
              color: selectedReasons[record.cabid] ? "#1890ff" : "#ccc",
              cursor: selectedReasons[record.cabid] ? "pointer" : "not-allowed",
              pointerEvents: selectedReasons[record.cabid] ? "auto" : "none",
            }}
          >
            {text}
          </a>
        ),
      },
      {
        title: "Distance",
        dataIndex: "distance",
        key: "distance",
      },
      {
        title: "Vehicle",
        dataIndex: "cabtype",
        key: "cabtype",
      },
      {
        title: "Driver Name",
        dataIndex: "drivername",
        key: "drivername",
        render: (text: any) => <span>{text}</span>,
      },
      {
        title: "Mobile No",
        dataIndex: "drivermobileno",
        key: "drivermobileno",
        render: (text: any) => text?.slice(-10),
      },
      {
        title: "Location",
        dataIndex: "location",
        key: "location",
        width: 200,
        render: (text: any) => (
          <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
            {text || "-"}
          </div>
        ),
      },
      {
        title: "Reason",
        dataIndex: "reason",
        key: "reason",
        width: 250,
        render: (text: any, record: any) => (
          <Select
            placeholder="Select reason"
            style={{ width: "100%" }}
            value={selectedReasons[record.cabid] || undefined}
            onChange={(value) => handleReasonChange(record.cabid, value)}
          >
            <Select.Option value="Vehicle issue">Vehicle issue</Select.Option>
            <Select.Option value="Trip not taken">Trip not taken</Select.Option>
            <Select.Option value="Location Change-Tech">Location Change-Tech</Select.Option>
            <Select.Option value="Location Change-Driver">Location Change-Driver</Select.Option>
            <Select.Option value="Long Distance">Long Distance</Select.Option>
            <Select.Option value="Location Change-Customer">Location Change-Customer</Select.Option>
            <Select.Option value="Wrongly assigned">Wrongly assigned</Select.Option>
            <Select.Option value="Wrongly booked">Wrongly booked</Select.Option>
            <Select.Option value="Driver have another trip">Driver have another trip</Select.Option>
            <Select.Option value="Driver Logout">Driver Logout</Select.Option>
            <Select.Option value="Vehicle change">Vehicle change</Select.Option>
            <Select.Option value="Document complaint">Document complaint</Select.Option>
            <Select.Option value="Traffic">Traffic</Select.Option>
            <Select.Option value="Driver no response">Driver no response</Select.Option>
            <Select.Option value="Tarpaulin not available">Tarpaulin not available</Select.Option>
            <Select.Option value="Other">Other</Select.Option>
          </Select>
        ),
      },
      {
        title: "Total Trips",
        dataIndex: "totaltrip",
        key: "totaltrip",
      },
      {
        title: "Total Amount",
        dataIndex: "tripfare",
        key: "tripfare",
        render: (text: any, record: any) => {
          return {
            props: {
              style: {
                background:
                  record.tripfare === 0
                    ? "#f5d7c6"
                    : record.tripfare >= 1 && record.tripfare <= 499
                      ? "#f2ee9d"
                      : record.tripfare >= 499 && record.tripfare <= 1000
                        ? "#b0d4a0"
                        : "#fff",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
    ];

    // Conditionally add the "Home" column after 6 PM
    const currentHour = new Date().getHours();
    if (currentHour >= 18) {
      columns.push({
        title: "Home",
        dataIndex: "startlocation",
        key: "Home",
      });
    }

    // Add any remaining columns
    columns.push(
      {
        title: "Minutes",
        dataIndex: "lastcompletedtime",
        key: "minutes",
        render: (text: any) =>
          Math.round(moment.duration(moment().diff(moment(text))).asMinutes()),
      }
    );

    return columns;
  };


  const selectedCabModal = (value: string) => {
    if (!selectedRowData.length) return; // no row selected
    getSelectedCabList(value);
    setGridModalVisible(true);
  };

  const getSelectedCabList = async (value: string) => {
    if (!selectedRowData.length) return;

    setModalLoading(true);

    const options = {
      params: {
        cityid: branchid,
        cabid: value, // input from Search box
        fromlat: selectedRowData[0].fromloclat,
        fromlong: selectedRowData[0].fromloclong,
      },
    };

    try {
      const resp = await axiosGet(UrlConstants.getselectedcab, options);
      setAvailableCabData(resp.data); // populate Reassignmodal
    } catch (error) {
      console.error("Error fetching selected cab:", error);
      message.error("Failed to fetch cab details.");
    } finally {
      setModalLoading(false);
    }
  };

  const showGridModal = () => {
    getAvailableCabList(selectedRowData);
    setGridModalVisible(true);

  };
  const NavigateModal = () => {
    getNavigateCabList(selectedRowData);
    setGridModalVisible(true);
  };
  const selectedcabModal = () => {
    getselectedcabList(selectedRowData);
    setGridModalVisible(true);
  };


  const hideModal = (isVisible: boolean) => {
    setGridModalVisible(isVisible);
    if (!isVisible) {
      setAvailableCabData([]);
      setselectedCab("");
    }

    getCurrentBookingList(pagination, SearchText);
  };


  const showFormModal = () => {
    setFormModalVisible(true);
  };
  useEffect(() => {
    if (farePreview) {
      console.log("Fare Preview Updated:", farePreview);
    }
  }, [farePreview]);
  const showCloseFormModal = async () => {
    if (!selectedRowData?.length) return;

    setModalLoading(true);

    const options = {
      params: {
        bookid: selectedRowData[0].id,
      },
    };
    if (selectedRowData[0].faretype.includes("Intercity Fare")) {
      try {

        const resp = await axiosGet(
          UrlConstants.fetchintercityfare,
          options
        );

        console.log("API Response:", resp);
        setfarePreview(resp);
        console.log("Fare Preview:", farePreview);
        setCloseModalVisible(true);
      } catch (error) {
        console.error("Error fetching Fare ", error);
        message.error("Failed to fetch Fare.");
      } finally {
        setModalLoading(false);
      }
    }
    else if (selectedRowData[0].faretype.includes("Meter Fare")) {
      try {

        const resp = await axiosGet(
          UrlConstants.fetchmetrefare,
          options
        );

        console.log("API Response:", resp);
        setfarePreview(resp);
        console.log("Fare Preview:", farePreview);
        setCloseModalVisible(true);
      } catch (error) {
        console.error("Error fetching Fare ", error);
        message.error("Failed to fetch Fare.");
      } finally {
        setModalLoading(false);
      }
    }
    else if (selectedRowData[0].faretype.includes("Night Fare")) {
      try {

        const resp = await axiosGet(
          UrlConstants.fetchnightfare,
          options
        );

        console.log("API Response:", resp);
        setfarePreview(resp);
        console.log("Fare Preview:", farePreview);
        setCloseModalVisible(true);
      } catch (error) {
        console.error("Error fetching Fare ", error);
        message.error("Failed to fetch Fare.");
      } finally {
        setModalLoading(false);
      }
    }
    else if (selectedRowData[0].faretype.includes("Package Fare")) {
      try {

        const resp = await axiosGet(
          UrlConstants.fetchpackagefare,
          options
        );

        console.log("API Response:", resp);
        setfarePreview(resp);
        console.log("Fare Preview:", farePreview);
        setCloseModalVisible(true);
      } catch (error) {
        console.error("Error fetching Fare ", error);
        message.error("Failed to fetch Fare.");
      } finally {
        setModalLoading(false);
      }
    }
  };


  const hideFormModal = (isVisible: any) => {
    getCurrentBookingList(pagination, SearchText);
    setFormModalVisible(isVisible);
  };
  const hideCloseFormModal = (isVisible: any) => {
    getCurrentBookingList(pagination, SearchText);
    setCloseModalVisible(isVisible);
  };
  const showCancelFormModal = () => {
    setCancelFormModalVisible(true);
  };

  const hideCancelFormModal = (isVisible: any) => {
    getCurrentBookingList(pagination, SearchText);
    setCancelFormModalVisible(isVisible);
  };

  const onGridRowSelect = (rowInfo: any) => {
    const isSelected = rowInfo.length > 0;
    setIsRowSelected(isSelected);
    setIsComplete(isSelected);
    setSelectedRowData(rowInfo);

    if (isSelected) {
      setreassigndisabled(rowInfo[0].tripstatuscode !== 4);
    } else {
      setreassigndisabled(false);
    }
  };

  const onReAssignBooking = (rowInfo: any, record: any, reason: string) => {
    const options = {
      data: {
        oldcabid: selectedRowData[0].cabid,
        bookid: selectedRowData[0].id,
        cabid: record.cabid,
        driverid: record.driverid,
        reassignby: employeename,
        emptyKM: record.distance,
        reason: reason,
      },
    };
    axiosPost(UrlConstants.reassignBooking, options)
      .then((resp: any) => {
        hideModal(false);
        const notificationInfo = {
          header: "Booking is Re-Assigned to " + record.cabid,
          description: "Booking is successfully Re-Assigned",
          // buttonText: "View Live Bookings",
          // path: "/currentBooking",
        };
        const notificationInfo1: any = {
          header:
            resp[0].sms === false
              ? "SMS sending failed"
              : "SMS Sent Successfully",
          description:
            resp[0].sms === false
              ? "SMS sending failed"
              : "SMS Sent Successfully",
        };
        openNotificationWithIcon("Success", notificationInfo1);
        openNotificationWithIcon(
          resp[0].sms === false ? "Error" : "Success",
          notificationInfo
        );
        getCurrentBookingList(pagination, SearchText);
      })
      .catch((error: any) => {
        if (error.response) {
          console.log(error.response.data, error.response.status);
        }
        const notificationInfo = {
          header: "Booking Re-Assign Failed",
          description: "Error Occurred while Re-Assigning Booking",
        };
        openNotificationWithIcon("Error", notificationInfo);
      });
  };

  const onBookingNavigation = (path: any) => {
    history.push("/booking" + path);
  };

  const openNotificationWithIcon = (type: any, info: any) => {
    const btn = info.buttonText && (
      <Button
        type="primary"
        size="small"
        onClick={() => onBookingNavigation(info.path)}
      >
        {info.buttonText}
      </Button>
    );
    if (type === "Success") {
      notification.success({
        message: info.header,
        description: info.description,
        btn,
      });
    } else if (type === "Error") {
      notification.error({
        message: info.header,
        description: info.description,
      });
    }
  };

  useEffect(() => {
    getCurrentBookingList(pagination, SearchText);
    //getAvailableCabList();
  }, []);

  const getCurrentBookingList = (pagination: any, SearchText: any) => {
    setIsLoading(true);
    const options: any = {
      params: {
        branchid: branchid,
        // limit: pagination.pageSize,
        // skip: (pagination.current - 1) * pagination.pageSize,
        filtervalue: SearchText,
      },
    };
    axiosGet(UrlConstants.getCurrentBooking, options)
      .then((resp: any) => {
        resp.data.forEach((e: any) => {
          e.key = e.id.toString();
        });
        setIsLoading(true);
        // const uri = UrlConstants.getCurrentBooking + "?branchid=" + branchid;
        // axiosGet(uri)
        //   .then((resp: any) => {
        //     resp.forEach((e: any) => {
        //       e.key = e.id.toString();
        //     });
        setIsLoading(false);
        setCurrentBookingGridData(resp.data);
        setcopyCurrentBookingGridData(resp.data);
        setTotalCount(resp.tablelength);
        ;
      })
      .catch(function (error: any) {
        setIsLoading(false);
        setCurrentBookingGridData([]);
        setcopyCurrentBookingGridData([]);
        if (error.response) {
          console.log(error.response.data, error.response.status);
        }
      });
  };

  // const getAvailableCabList = (rowinfo: any) => {
  //   setModalLoading(true);
  //   const options = {
  //     params: {
  //       branchid: branchid,
  //       vehicletype: rowinfo[0].vehicletypeid,
  //       roleid: Role,
  //       fromlat: rowinfo[0].fromloclat,
  //       fromlong: rowinfo[0].fromloclong,
  //     },
  //   };

  //   axiosGet(UrlConstants.getcabsforassign, options).then((resp: any) => {
  //     setAvailableCabData(resp.data);
  //     setModalLoading(false);
  //   });
  // };
  const getAvailableCabList = (rowinfo: any) => {
    setModalLoading(true);
    const options = {
      params: {
        branchid: branchid,
        vehicletype: rowinfo[0].vehicletypeid,
        roleid: Role,
        fromlat: rowinfo[0].fromloclat,
        fromlong: rowinfo[0].fromloclong,
      },
    };

    axiosGet(UrlConstants.getcabsforassign, options)
      .then((resp: any) => {
        if (resp?.data?.status === 404 || !resp?.data?.length) {
          message.warning(resp?.data?.message || "No cabs available");
          setAvailableCabData([]);

          return;
        }

        setAvailableCabData(resp.data);
        setModalLoading(true);
      })
      .catch((error: any) => {
        message.error(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setModalLoading(false);
      });
  };
  const getNavigateCabList = (rowinfo: any) => {
    setModalLoading(true);
    const options = {
      params: {
        branchid: branchid,
        vehicletype: rowinfo[0].vehicletypeid,
        roleid: Role,
        fromlat: rowinfo[0].fromloclat,
        fromlong: rowinfo[0].fromloclong,
      },
    };

    axiosGet(UrlConstants.getAvailableCabsNew, options).then((resp: any) => {
      setAvailableCabData(resp.data);
      setModalLoading(false);
    });
  };

  // const getselectedcabList = async (value: string) => {
  //   setselectedCab(value);
  //   setModalLoading(true);

  //   const options = {
  //     params: {
  //       cityid: branchid,
  //       cabid: value,
  //       fromlat: selectedRowData[0].fromloclat,
  //       fromlong: selectedRowData[0].fromloclong,
  //     },
  //   };

  //     const resp = await axiosGet(UrlConstants.getselectedcab, options);
  //     setAvailableCabData(resp.data);
  //     setModalLoading(false);
  // };
  const getselectedcabList = async (value: any) => {
    const cabId = value?.id || value; // if it's object, take its id
    setselectedCab(cabId);
    setModalLoading(true);

    const options = {
      params: {
        cityid: branchid,
        cabid: cabId,
        fromlat: selectedRowData[0].fromloclat,
        fromlong: selectedRowData[0].fromloclong,
      },
    };

    const resp = await axiosGet(UrlConstants.getselectedcab, options);
    setAvailableCabData(resp.data);
    setModalLoading(false);
  };

  const onPaginationchange = (pagination: any) => {
    setPagination(pagination);
    getCurrentBookingList(pagination, SearchText);
  };
  const onSearch = (value: any) => {
    setsearchText(value);
    getCurrentBookingList(pagination, value);
  };


  const makeautocomplete = (rowInfo: any, record: any, rowIndex: any) => {
    let emptyKm = record.distance;
    if (!emptyKm && emptyKm === 0) emptyKm = 1;
    const options = {
      data: {
        cabid: selectedRowData[0].cabid,
        bookid: selectedRowData[0].id,
        completeby: employeename,
        piclat: selectedRowData[0].toloclat,
        piclon: selectedRowData[0].toloclong,
        present_location: selectedRowData[0].toloc,
        vehicleid: selectedRowData[0].vehicletypeid,
        isadditionalfare: false,
        iscredit: selectedRowData[0].iscredit || false
      },
    };
    axiosPost(UrlConstants.autocomplete, options)
      .then((resp: any) => {
        hideModal(false);
        getCurrentBookingList(pagination, SearchText);
        console.log("resp", resp);
        const notificationInfo = {
          header: "Booking is Assigned to " + record.cabid,
          description:
            "You can see all the Live bookings by clicking below button",
          buttonText: "View Live Bookings",
          path: "/currentBooking",
        };
        const notificationInfoCustomer: any = {
          header:
            resp.customersms === false
              ? "Customer SMS sending failed"
              : "Customer SMS Sent Successfully",
          description:
            resp.customersms === false
              ? "Customer SMS sending failed"
              : "Customer SMS Sent Successfully",
        };
        const notificationInfoDriver: any = {
          header:
            resp.driversms === false
              ? "Driver SMS sending failed"
              : "Driver SMS Sent Successfully",
          description:
            resp.driversms === false
              ? "Driver SMS sending failed"
              : "Driver SMS Sent Successfully",
        };
        openNotificationWithIcon("Success", notificationInfo);
        openNotificationWithIcon(
          resp.customersms === false ? "Error" : "Success",
          notificationInfoCustomer
        );
        openNotificationWithIcon(
          resp.driversms === false ? "Error" : "Success",
          notificationInfoDriver
        );
      })
      .catch((error: any) => {
        if (error.response) {
        }
        const notificationInfo = {
          header: "Assigning Booking Failed",
          description: "Error Occurred while Assigning New Booking",
        };
        openNotificationWithIcon("Error", notificationInfo);
      });
  };


  return (
    <div className="booking-child-routes">
      <div className="booking-child-routes-button-section">
        <Row gutter={[8, 8]} align="middle">
          {/* Left-aligned items */}
          <Col>
            <Space size="middle" align="center">
              {selectedRowData?.[0]?.faretype === "Meter Fare" && (
                <RocketOutlined
                  onClick={() => isRowSelected && makeautocomplete(null, selectedRowData[0], null)}
                  style={{
                    fontSize: '32px',
                    color: 'green',
                    cursor: !isRowSelected ? 'not-allowed' : 'pointer',
                    opacity: !isRowSelected ? 0.5 : 1
                  }}
                />
              )}

              <Button
                className="booking-btn-reassign"
                disabled={!isRowSelected || !reassigndisabled}
                onClick={showGridModal}
              >
                ReAssign
              </Button>

              {Role === 1 && (
                <Button
                  className="booking-btn-navigate"
                  disabled={!isRowSelected || !reassigndisabled}
                  onClick={NavigateModal}
                >
                  Navigate
                </Button>
              )}
              <Button
                className="booking-btn-complete"
                disabled={!isRowSelected}
                onClick={showCloseFormModal}
                style={{ backgroundColor: "#38bdf8", borderColor: "#38bdf8", color: "#fff" }}
              >
                Close
              </Button>
              <Button
                className="booking-btn-complete"
                disabled={!isRowSelected}
                onClick={showFormModal}
              >
                Complete
              </Button>

              <Button
                className="booking-btn-cancel"
                disabled={!isRowSelected || !reassigndisabled}
                onClick={showCancelFormModal}
              >
                Cancel
              </Button>

              <Search
                placeholder="Find Cab"
                onSearch={selectedCabModal}
                enterButton
                disabled={!isRowSelected}
              />

              <Button
                icon={<RedoOutlined />}
                type="primary"
                onClick={() => getCurrentBookingList(pagination, SearchText)}
              />

              <span style={{ fontSize: 'large', fontWeight: 'bold' }}>
                Trips: {totalCount}
              </span>
            </Space>
          </Col>

          {/* Right-aligned Search Text */}
          <Col style={{ marginLeft: 'auto', minWidth: 300 }}>
            <Search
              placeholder="Search Text"
              onSearch={onSearch}
              enterButton
              allowClear
            />
          </Col>
        </Row>

      </div>

      <div>
        <Spin tip="Loading..." spinning={isLoading}>
          <AppTable
            columns={columns}
            data={copycurrentBookingGridData}
            rowClassName={(record: any) => record.tripstatus}
            enableRadioButton={true}
            onRadioButtonChange={onGridRowSelect}
            selectionType="radio"
            scroll={{ x: 2900, y: 480 }}
            enablePagination={true}
            defaultPageSize={100}
          ></AppTable>
        </Spin>
      </div>
      <Reassignmodal
        title="ReAssign Trip"
        modalGridColumns={modalReAssignColumns}
        visible={gridModelVisible}
        hideModal={hideModal}
        width={'fit-content'}
        isLoading={modalloading}
        selectedRowData={selectedRowData}
        isAddbooking={false}
        modalGridData={availableCabData}
        onRowClickEnabled={false}
        onRowClick={onReAssignBooking}
        customClass="new-booking-assign"
      />
      <Completeform
        title="Complete Booking"
        visible={formModalVisible}
        hideModal={hideFormModal}
        selectedRowData={selectedRowData}
      />
      <TripClose
        title="Close Trip"
        visible={CloseModalVisible}
        hideModal={hideCloseFormModal}
        selectedRowData={selectedRowData}
        farePreview={farePreview}
      />
      <AppModalWithCancelForm
        title="Cancel Booking"
        visible={cancelformModalVisible}
        hideModal={hideCancelFormModal}
        selectedRowData={selectedRowData}
      />
    </div>
  );
};

export default CurrentBooking;
